import Shark from '.'
import Experience from '..'
import CopyPass from './shaders/copy-shader/copy'
import SamplerMaterial from './shaders/sample-shader-default/material'

/**
 * Build the shark texture based on the shark image target
 * and copyPass/sampleMaterial magic! (Deim's work <3)
 *
 * "copyPass"
 *      ~ Takes a “capture” of the camera
 * "samplerMaterial"
 *      - Adjusts that image for perspective and position
 */
export default class TextureBuilder {
  private experience = new Experience()
  private shark: Shark

  private copyPass!: CopyPass
  private copyPassBackup!: CopyPass

  private samplerMaterial!: SamplerMaterial

  private lastElapsedTime = 0
  private deltaTimeTemp = 0
  private initialised = false

  public updateCopyPass = true
  public samplerMaterialBackup!: SamplerMaterial

  constructor(shark: Shark) {
    this.shark = shark
    this.init()
  }

  private init() {
    this.copyPass = new CopyPass(this.experience.camera.zapparCamera)
    this.copyPassBackup = new CopyPass(this.experience.camera.zapparCamera)

    this.samplerMaterial = new SamplerMaterial()
    this.samplerMaterialBackup = new SamplerMaterial()
  }

  public update() {
    // if (this.updateCopyPass) {
    // console.log('update material')

    // Calculate time interval values for when
    // the material backup should happen
    const elapsedTime = this.experience.clock.getElapsedTime()
    const deltaTime = elapsedTime - this.lastElapsedTime
    this.lastElapsedTime = elapsedTime
    this.deltaTimeTemp += deltaTime

    // Generate sampler material
    this.copyPass.render(this.experience.renderer.instance)

    this.samplerMaterial.render(
      this.experience.camera.zapparCamera,
      this.copyPass.texture,
      this.experience.renderer.instance,
      this.shark.imageTracker.imageTrackerGroup
    )

    // Trigger backup every ~1.0s or
    // if backup not initialised (= first start)
    const shouldBackup = this.deltaTimeTemp >= 1.0 || !this.initialised

    if (shouldBackup) {
      this.copyPassBackup.render(this.experience.renderer.instance)

      this.samplerMaterialBackup.render(
        this.experience.camera.zapparCamera,
        this.copyPassBackup.texture,
        this.experience.renderer.instance,
        this.shark.imageTracker.imageTrackerGroup
      )

      this.initialised = true
      this.deltaTimeTemp = 0
    }

    // Real time shark material update
    this.shark.updateDefaultMaterial(this.samplerMaterial)
    // }
  }
}
